import { EntityTemplateVariables, TemplateVariable } from '@tools/interfaces/template';

export const getPaymentFieldsForEntity = (entity: string): TemplateVariable[] => {
  return [
    {
      label: 'templates.payments.code.label',
      contentValue: `{{ ${entity}payment.code }}`,
      description: 'templates.payments.code.description',
    },
    {
      label: 'templates.payments.status.label',
      contentValue: `{{ ${entity}payment.status }}`,
      description: 'templates.payments.status.description',
    },
    {
      label: 'templates.payments.payment_date.label',
      contentValue: `{{ ${entity}payment.payment_date | date("d/m/Y") }}`,
      description: 'templates.payments.payment_date.description',
    },
    {
      label: 'templates.payments.payment_time.label',
      contentValue: `{{ ${entity}payment.payment_time | date("H:i") }}`,
      description: 'templates.payments.payment_time.description',
    },
    {
      label: 'templates.payments.paid_amount.label',
      contentValue: `{{ ${entity}payment.paid_amount }}`,
      description: 'templates.payments.paid_amount.description',
    },
    {
      label: 'templates.payments.payment_method_type.label',
      contentValue: `{{ ${entity}payment.payment_method_type }}`,
      description: 'templates.payments.payment_method_type.description',
    },
    {
      label: 'templates.payments.comment.label',
      contentValue: `{{ ${entity}payment.comment }}`,
      description: 'templates.payments.comment.description',
    },
    {
      label: 'templates.payments.origin.label',
      contentValue: `{{ ${entity}payment.origin }}`,
      description: 'templates.payments.origin.description',
    },
  ];
};

export const templatePayment: EntityTemplateVariables = {
  fields: getPaymentFieldsForEntity(''),
  related: [],
  relatedInLoop: [],
};
